var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getDeviceHealthService, } from 'services/deviceService/deviceHealth.service';
export var GET_DEVICE_HEALTH = 'GET_DEVICE_HEALTH';
export var SET_DEVICE_HEALTH_DATA = 'SET_DEVICE_HEALTH_DATA';
export var SET_DEVICE_HEALTH_ERROR = 'SET_DEVICE_HEALTH_ERROR';
export var SET_DEVICE_HEALTH_PAGE = 'SET_DEVICE_HEALTH_PAGE';
export var SET_DEVICE_HEALTH_SEARCH_QUERY = 'SET_DEVICE_HEALTH_SEARCH_QUERY';
export var SET_DEVICE_HEALTH_FILTER = 'SET_DEVICE_HEALTH_FILTER';
export var RESET_DEVICE_HEALTH = 'RESET_DEVICE_HEALTH';
export var getAllDeviceHealthData = function (searchQuery, searchType, limit) {
    if (searchQuery === void 0) { searchQuery = ''; }
    if (searchType === void 0) { searchType = 'name'; }
    if (limit === void 0) { limit = 25; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var firstPage, members, totalPages, page, response;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    dispatch({ type: GET_DEVICE_HEALTH });
                    return [4 /*yield*/, getDeviceHealthService(searchQuery, searchType, 1, limit)];
                case 1:
                    firstPage = _d.sent();
                    members = __spreadArray([], firstPage.members, true);
                    totalPages = (_b = (_a = firstPage.pagination) === null || _a === void 0 ? void 0 : _a.total_pages) !== null && _b !== void 0 ? _b : 1;
                    page = 2;
                    _d.label = 2;
                case 2:
                    if (!(page <= totalPages)) return [3 /*break*/, 5];
                    return [4 /*yield*/, getDeviceHealthService(searchQuery, searchType, page, limit)];
                case 3:
                    response = _d.sent();
                    members.push.apply(members, response.members);
                    _d.label = 4;
                case 4:
                    page += 1;
                    return [3 /*break*/, 2];
                case 5: return [2 /*return*/, {
                        data: members,
                        pagination: firstPage.pagination,
                        summary: (_c = firstPage.summary) !== null && _c !== void 0 ? _c : {},
                    }];
            }
        });
    }); };
};
export var setDeviceHealthData = function (payload) { return ({
    type: SET_DEVICE_HEALTH_DATA,
    payload: payload,
}); };
export var setDeviceHealthError = function (error) {
    var _a, _b;
    return ({
        type: SET_DEVICE_HEALTH_ERROR,
        payload: ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            'Unable to load device health data.',
    });
};
export var setDeviceHealthPage = function (page) { return ({
    type: SET_DEVICE_HEALTH_PAGE,
    payload: page,
}); };
export var setDeviceHealthSearchQuery = function (query) { return ({
    type: SET_DEVICE_HEALTH_SEARCH_QUERY,
    payload: query || '',
}); };
export var setDeviceHealthFilter = function (filter) { return ({
    type: SET_DEVICE_HEALTH_FILTER,
    payload: filter,
}); };
export var resetDeviceHealth = function () { return ({
    type: RESET_DEVICE_HEALTH,
}); };
